import {Injectable} from "@angular/core";
import {MatTableDataSource} from "@angular/material/table";
@Injectable({
    providedIn: "root"
})
// @ts-ignore
export class SearchFilterService {

    //first value is value to filter by, second value is the list of objects you need to filter, in MatTableDataSource format
    search(filterValue: string, list: MatTableDataSource<any>) {
        list.filterPredicate = (data: any, filter: string): boolean => {
            const dataStr = Object.keys(data).reduce((currentTerm: string, key: string) => {
                return (currentTerm + (data as {[key: string]: any}) [key])
            }, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

            const transformedFilter = filter.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

            return dataStr.indexOf(transformedFilter) !== -1;
        }
        return list.filter = filterValue.trim().toLowerCase();
    }
    //Currently set to ticket model & dateTimeCreatedBy - if used elsewhere these will need to change
    searchDate(fromDate: string, toDate: string, list: MatTableDataSource<any>) {
        const fromTime = new Date(fromDate).getTime();
        const toTime = new Date(toDate).getTime();
        list.filterPredicate = (data: any) => {
            return new Date(data.createdTime).getTime() >= fromTime &&
                new Date(data.createdTime).getTime() <= toTime;
        }
        list.filter = (fromDate + toDate);
    }
}
